module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "soproni_small_area for_new_page",
    staticStyle: {
      "padding": "0 0"
    }
  }, [(_vm.page.widgets && _vm.page.widgets[0] && _vm.page.widgets[0].type == 'ImageSliderWidget') ? _c('image-slider-widget', {
    attrs: {
      "widget": _vm.page.widgets[0]
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.page.widgets), function(widget, index) {
    return (widget.type != 'ImageSliderWidget') ? [_c(widget.type, {
      key: index,
      tag: "component",
      attrs: {
        "widget": widget
      }
    })] : _vm._e()
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64ba6e76","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/page/CustomPage.vue
// module id = 116
// module chunks = 0 1 2